import { type ResumeChatResponse } from "../api";
import { Utility } from "./utility";

export interface ResumeChat extends ResumeChatResponse {}

export class ResumeChat extends Utility<ResumeChat> {
  constructor(init?: Partial<ResumeChatResponse>) {
    super();
    Object.assign(this, init);
  }
}
